import { Injectable, signal } from '@angular/core';
import { REGISTRATION_ID } from '../@constants/local-storage-key-constants';
import {
  getLocalStorageItem,
  setLocalStorageItem,
} from '../@utils/local-storage-util';

const state = {
  registrationId: signal<string>(''),
};

@Injectable({
  providedIn: 'root',
})
export class ExternalRegistrationStateService {
  constructor() {
    this._initializeRegistrationId();
  }

  public readonly $registrationId = state.registrationId.asReadonly();

  setRegistrationId(registrationId: string | null): void {
    const finalRegistrationId = registrationId || 'unknown';
    state.registrationId.set(finalRegistrationId);
    setLocalStorageItem(REGISTRATION_ID, finalRegistrationId);
  }

  private _initializeRegistrationId(): void {
    const storedRegistrationId = getLocalStorageItem<string>(REGISTRATION_ID);
    if (storedRegistrationId) {
      state.registrationId.set(storedRegistrationId);
    }
  }
}
